<template lang="html">
<div>

    <div class="subpage">

        <div v-if="!srcList.length" class="lineBar">
              <el-button @click="addAttes" type="primary" style="width:80px;" size="small">创建</el-button>
        </div>

        <table class="mTable">

             <tr>
                 <td>认证通过日期</td>
                 <td>主体</td>
                 <td>身份类别</td>
                 <td>申请人（管理员）</td>
                 <td>证件</td>
                 <td>公函</td>
             </tr>
             <tr v-for="item in srcList" v-if="item.status == 2">
                 <td>{{item.createdAt.substr(0,11)}}</td>
                 <td>{{item.subjectType}}</td>
                 <td>{{item.identityType}}</td>
                 <td>{{item.applicantName}}</td>
                 <td>
                     <el-image
                        style="width: 100px; height: 100px"
                        ref="imgPop"
                        :src="item.url1"
                        :preview-src-list="item.previewList">
                    </el-image>
                    <!-- <span @click="imgView(item,item.businessLicense)" class="ibtn">查看</span> -->
                 </td>
                 <td>
                     <el-image
                        style="width: 100px; height: 100px"
                        ref="imgPop"
                        :src="item.url2"
                        :preview-src-list="item.previewList">
                    </el-image>
                    <!-- <span @click="imgView(item,item.applicationCertDocId)" class="ibtn">查看</span> -->
                 </td>
             </tr>

        </table>

    </div>

    <!-- <newAttes @goStore="goStore" ref="newAttes" /> -->

    

</div>
</template>

<script>
import newAttes from "./cModel";
import { getViewKey } from '@/api/account';
export default {
    props:['entid'],
    components:{
        newAttes
    },

    data(){
        return{
            params:{},
            firmStore:'',
            srcList:[],
            viewDat:{},
            previewList:[],
            url:''
        }
    },

    methods:{
        preEdit:function(e){
            if(e.enterpriseCertificationInfo){
                this.srcList.push(e.enterpriseCertificationInfo);
                for(var index in this.srcList){
                    var src = this.srcList[index];
                    src.url1=this.viewDat.imagePreUrl + '/id/' + src.businessLicense + '/token/' + this.viewDat.token;
                    src.url2=this.viewDat.imagePreUrl + '/id/' + src.applicationCertDocId + '/token/' + this.viewDat.token;
                    src.previewList=[
                        this.viewDat.imagePreUrl + '/id/' + src.businessLicense + '/token/' + this.viewDat.token,
                        this.viewDat.imagePreUrl + '/id/' + src.applicationCertDocId + '/token/' + this.viewDat.token];
                }
                // console.log(this.srcList);
                // this.previewList = [this.viewDat.imagePreUrl + '/id/' + id + '/token/' + this.viewDat.token];
            }
        },
        goStore:function(e){
            this.firmStore = {};
            for(var key in e){
                this.firmStore[key] = e[key];
            }
        },
        saveReturn:function(){
            return this.firmStore;
        },
        addAttes:function(){
            this.$refs.newAttes.openstate = true;
        },
        imgView:function(item,id){
            this.url=this.viewDat.imagePreUrl + '/id/' + id + '/token/' + this.viewDat.token;
            this.previewList = [
                this.viewDat.imagePreUrl + '/id/' + item.businessLicense + '/token/' + this.viewDat.token,
                this.viewDat.imagePreUrl + '/id/' + item.applicationCertDocId + '/token/' + this.viewDat.token];
            console.log(this.$refs);
            this.$refs.imgPop.loadImage();
        }
    },

    created:function(){

        getViewKey().then(res => {
            this.viewDat = {
                imagePreUrl:res.imagePreUrl,
                token:res.token
            };
        })

    }
}
</script>

<style lang="scss" scoped>

.subpage{
      font-size: 15px;
     .pgLeft{
          width: 60px;
          float: left
     }
     .pgContent{
          margin-left: 60px;
          position: relative;

     }

     .mTable{
         width: 100%;
         border-collapse: collapse;
         margin-top: 20px;
         td{
             text-align: center;
             padding: 8px 12px;
             border: 1px solid #ebeef5;
             color: #999999;
         }
     }

}

</style>



// WEBPACK FOOTER //
// Subpage2.vue?147a2204